/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  toImageCdnSearchParams.ts
 */

import { ImageCdnParams } from './ImageCdnParams'

type ValueOf<T> = T[keyof T]

export const stringifyParamValue = (
  paramValue: NonNullable<ValueOf<ImageCdnParams>>
) => (Array.isArray(paramValue) ? paramValue.join(',') : paramValue.toString())

export const toImageCdnSearchParams = (params: ImageCdnParams) => {
  const entries: string[][] = []
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      entries.push([key, stringifyParamValue(value)])
    }
  }
  return new URLSearchParams(entries)
}
